import { RouteRecordRaw } from "vue-router";
import ReportsView from "./views/ReportsView.vue";
import StudentsView from "./views/StudentsView.vue";
import ActivityView from "./views/ActivityView.vue";
import JourneysView from "./views/JourneysView.vue";
import ProgressView from "./views/ProgressView.vue";
import AdminView from "./views/AdminView.vue";
import SuperAdminView from "./views/SuperAdmin.vue";
import OverviewPage from "./views/OverviewPage.vue";
import InternalView from "./views/InternalView.vue";
import InternalEditSchoolView from "./views/InternalEditSchoolView.vue";
import InternalArchiveView from "./views/InternalArchiveView.vue";
import InternalWondeImportView from "./views/InternalWondeImportView.vue";
import IncompleteRolloverView from "./views/IncompleteRolloverView.vue";
import ReviewClassStructureView from "./views/ReviewClassStructureView.vue";
import AddStudentView from "./views/AddStudentView.vue";
import AddStudentToClassView from "./views/AddStudentToClassView.vue";
import RolloverInProgressVue from "./views/RolloverInProgress.vue";
import ProfileView from "./views/ProfileView.vue";
import ClassReportsView from "./views/ClassReportsView.vue";

export const mainRoutes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/main/overview",
  },
  {
    path: "overview",
    component: OverviewPage,
    name: "overview",
  },
  {
    path: "journeys",
    name: "journeys",
    component: JourneysView,
  },
  {
    path: "progress",
    name: "progress",
    component: ProgressView,
  },
  {
    path: "reports",
    name: "reports",
    component: ReportsView,
  },
  {
    path: "students",
    name: "students",
    component: StudentsView,
  },
  {
    path: "activity",
    name: "activity",
    component: ActivityView,
  },
  {
    path: "admin",
    name: "admin",
    component: AdminView,
  },
  {
    path: "super-admin",
    name: "super-admin",
    component: SuperAdminView,
  },
  {
    path: "internal",
    name: "internal",
    component: InternalView,
  },
  {
    path: "profile",
    name: "profile",
    component: ProfileView,
  },
  {
    path: "internal-edit-school",
    name: "internal-edit-school",
    component: InternalView,
  },
  {
    path: "internal-achive",
    name: "internal-achive",
    component: InternalArchiveView,
  },
  {
    path: "internal-wonde-import",
    name: "internal-wonde-import",
    component: InternalWondeImportView,
  },

  {
    path: "incomplete-rollover",
    name: "incomplete-rollover",
    component: IncompleteRolloverView,
    meta: {
      requiresRolloverLearnersReview: true,
    },
  },
  {
    path: "rollover-in-progress",
    name: "rollover-in-progress",
    component: RolloverInProgressVue,
  },
  {
    path: "review-class-structure",
    name: "review-class-structure",
    component: ReviewClassStructureView,
    meta: {
      requiresRolloverClassReview: true,
    },
  },
  {
    path: "add-student",
    name: "add-student",
    component: AddStudentView,
    meta: {
      requiresRolloverExecution: true,
    },
  },
  {
    path: "add-student-to-class/:classId",
    name: "add-student-to-class",
    component: AddStudentToClassView,
    meta: {
      requiresRolloverExecution: true,
    },
  }
];
